export const eventsRouteNames = {
  Events: 'events/events',
  EventSingle: 'events/event-single',
  EventDetail: 'events/event-detail',
}
